module.exports = __webpack_public_path__ + "img/hero.34b92a91.svg";